import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Controller from "csi/action/Controller";
import csi from "csi/main";
import Delete from "csi/table/Delete";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import PostRequest from "csi/comm/PostRequest";
import xml from "csi/xml";


const DeleteShapeStyle = declare(Delete, {

	confirmAction(params:Object) {
		this.setProgress();
		new PostRequest("ProductSpec", "ValidateShapeStyleDS")
			.addParameter(xml.PROP_URL_PARENT, this.m_urlNode)
			.post({})
			.then(lang.hitch(this, this._onValidateResponse));
	},

	_onValidateResponse(response: any) {
		if (response.getReturnValue()) {
			this._confirm("WARNING", "Style", "RemoveStyleFromShape_Confirm");
		} else {
			this._confirm("WARNING", "Style", "RemoveStyleFromShapeNoLinked_Confirm");
		}
	},

	onConfirm(key: string) {
		if (key == MessageDialog.BUTTON_CANCEL) {
			this.postProcess();
		} else if (key == MessageDialog.BUTTON_REMOVE) {
			this.process();
		} else {
			// the delete action always has a confirmation dialog, thus its preProcess opens Confirmation Dialog
			Controller.prototype.preProcess.call(this);
		}
	},

	toWriter() {
		this.m_writer.changeNode(this.m_urlNode).changeAttribute("Shape", xml.ATTR_REF, csi.EMPTY_URL);
	},

	_confirm(titleKey: string, messageKey: string, localeMsg: string) {
		Controller.prototype.confirmAction.call(this, {
			materialIcon: MessageDialog.ICON_WARNING,
			buttons: [MessageDialog.BUTTON_REMOVE, MessageDialog.BUTTON_CANCEL],
			message: locale.typeAction(messageKey, localeMsg),
			title: locale.resource(titleKey),
		});
	},

});

export = DeleteShapeStyle;
